export const a1005Dictionary = [
    {
        value: 'A',
        description: 'No, not of Hispanic, Latino/a, or Spanish origin',
        mutuallyExclusiveWith: ['B', 'C', 'D', 'E'],
    },
    {
        value: 'B',
        description: 'Yes, Mexican, Mexican American, Chicano/a',
        mutuallyExclusiveWith: ['A', 'X', 'Y'],
    },
    {
        value: 'C',
        description: 'Yes, Puerto Rican',
        mutuallyExclusiveWith: ['A', 'X', 'Y'],
    },
    {
        value: 'D',
        description: 'Yes, Cuban',
        mutuallyExclusiveWith: ['A', 'X', 'Y'],
    },
    {
        value: 'E',
        description: 'Yes, another Hispanic, Latino, or Spanish origin',
        mutuallyExclusiveWith: ['A', 'X', 'Y'],
    },
    {
        value: 'X',
        description: 'Patient unable to respond',
        mutuallyExclusiveWith: ['A', 'B', 'C', 'D', 'E', 'Y'],
    },
    {
        value: 'Y',
        description: 'Patient declines to respond',
        mutuallyExclusiveWith: ['A', 'B', 'C', 'D', 'E', 'X'],
    },
];
export const a1010Dictionary = [
    {
        value: 'A',
        description: 'White',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'B',
        description: 'Black or African American',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'C',
        description: 'American Indian or Alaska Native',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'D',
        description: 'Asian Indian',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'E',
        description: 'Chinese',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'F',
        description: 'Filipino',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'G',
        description: 'Japanese',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'H',
        description: 'Korean',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'I',
        description: 'Vietnamese',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'J',
        description: 'Other Asian',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'K',
        description: 'Native Hawaiian',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'L',
        description: 'Guamanian or Chamorro',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'M',
        description: 'Samoan',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'N',
        description: 'Other Pacific Islander',
        mutuallyExclusiveWith: ['X', 'Y', 'Z'],
    },
    {
        value: 'X',
        description: 'Patient unable to respond',
        mutuallyExclusiveWith: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'Y', 'Z'],
    },
    {
        value: 'Y',
        description: 'Patient declines to respond',
        mutuallyExclusiveWith: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'X', 'Z'],
    },
    {
        value: 'Z',
        description: 'None of the above',
        mutuallyExclusiveWith: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'X', 'Y'],
    },
];
/** M0100 — reason for assessment. `value` matches the OASIS code. `timepoint` is the visit form timepoint. */
export const reasonForAssessmentDictionary = [
    { value: '01', timepoint: 'soc', description: '01 - Start of care — further visits planned' },
    { value: '03', timepoint: 'roc', description: '03 - Resumption of care (after inpatient stay)' },
    { value: '04', timepoint: 'rct', description: '04 - Recertification (follow-up) reassessment' },
    { value: '05', timepoint: 'ofu', description: '05 - Other follow-up' },
    { value: '06', timepoint: 'tr', description: '06 — Transferred to an inpatient facility, episode remains open' },
    { value: '07', timepoint: 'trd', description: '07 — Transferred to an inpatient facility and discharged' },
    { value: '08', timepoint: 'dth', description: '08 — Died at home' },
    { value: '09', timepoint: 'dsch', description: '09 — Discharged from the agency' },
];
export function reasonForAssessmentForTimepoint(timepoint) {
    const match = reasonForAssessmentDictionary.find((item) => item.timepoint === timepoint);
    return match?.value ?? null;
}
export function reasonForAssessmentDescription(value) {
    return reasonForAssessmentDictionary.find((item) => item.value === value)?.description;
}
